<template>
  <div class="charts_el" ref="chartsEl"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "GjkcH5QuestionAnalysisBar",

  data() {
    return {};
  },

  mounted() {
    // this.initCharts();
  },

  methods: {
    initCharts(salvProName,salvProValue) {
      var chartDom = this.$refs.chartsEl;
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        backgroundColor: "#fff",
        grid: {
          left: "3%",
          right: "5%",
          bottom: "10%",
          top: "10%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
          formatter: function (params) {
            return params[0].name + " : " + params[0].value;
          },
        },
        xAxis: {
          show: true,
          splitLine: {
            show: true,
            textStyle: {
              color: "#333",
            },
            lineStyle: {
              color: "#8c8c8c",
              type: "dashed",
            },
          },
          axisLine: {
            show: true,
            textStyle: {
              color: "#333",
            },
            lineStyle: {
              color: "#8c8c8c",
              type: "dashed",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: true,
          },
          type: "value",
        },
        yAxis: [
          {
            type: "category",
            inverse: true,
            boundaryGap: true,
            axisLabel: {
              show: true,
              lineStyle: {
                color: "#f2f2f2",
              },
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            data: salvProName,
          },
        ],
        series: [
          {
            // name: '值',
            type: "bar",
            zlevel: 1,

            itemStyle: {
              normal: {
                barBorderRadius: [0, 10, 10, 0],
                color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                  {
                    offset: 0,
                    color: "rgb(57,89,255,1)",
                  },
                  {
                    offset: 1,
                    color: "rgb(46,200,207,1)",
                  },
                ]),
              },
            },
            barWidth: 20,
            data: salvProValue,
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.charts_el {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
